import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title this.siteData.siteTitle}}\n{{outlet}}\n<NotificationContainer @position=\"top\" />\n<PortalTarget @name=\"splash-overlay\" />\n<NwKbar />")